
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText, Download } from "lucide-react";
import { Link } from "react-router-dom";
import { Guide } from "@/types/guides";

interface GuideCardProps {
  guide: Guide;
  defaultCoverImage: string;
  onPreview: (e: React.MouseEvent, guide: Guide) => void;
  onDownload: (e: React.MouseEvent, guide: Guide) => void;
}

export function GuideCard({ guide, defaultCoverImage, onPreview, onDownload }: GuideCardProps) {
  return (
    <Link key={guide.id} to={`/guides/${guide.slug}`}>
      <Card className="overflow-hidden border-grandpal-beige group hover:shadow-md transition-all duration-300">
        <CardContent className="p-6">
          <div className="mb-4 h-64 overflow-hidden rounded-lg">
            <img
              src={guide.cover_image_url || defaultCoverImage}
              alt={guide.title}
              className="w-full h-full object-cover"
            />
          </div>
          <h3 className="text-2xl font-semibold mb-4 text-grandpal-green-dark">{guide.title}</h3>
          <p className="text-grandpal-gray mb-6">{guide.description}</p>
          <div className="flex flex-wrap gap-2 mb-4">
            {guide.categories && guide.categories.map((category, idx) => (
              <span 
                key={`${guide.id}-${idx}-${category}`} 
                className="text-xs px-3 py-1 bg-white/90 backdrop-blur-sm text-grandpal-green-dark rounded-full shadow-sm"
              >
                {category}
              </span>
            ))}
          </div>
          <div className="flex gap-4">
            <Button 
              variant="outline" 
              className="border-grandpal-green text-grandpal-green-dark hover:bg-grandpal-green/10 flex-1"
              onClick={(e) => onPreview(e, guide)}
            >
              <FileText className="mr-2 h-5 w-5" />
              Preview
            </Button>
            <Button 
              className="bg-grandpal-green-dark text-white hover:bg-grandpal-green-dark/90 flex-1"
              onClick={(e) => onDownload(e, guide)}
            >
              <Download className="mr-2 h-5 w-5" />
              Download
            </Button>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
